import {ImportingDataTypes} from "../../types";
import {
    createProductRelationAutocompleteField,
    PreventionInvalidityCode,
    PreventativeAutocompleteType,
} from "./shared";

const createPartAutocompleteField = (key, label, {appliesToIssue} = {}) => ({
    key,
    label,
    type: PreventativeAutocompleteType.PART,
    appliesToIssue,
    modifyRowUsesPatchValue: true,
    extractValue: (o) => (typeof o === 'string' ? o : o?.partNo ?? null),
    modifyRow: (row, val) => ({
        ...row,
        [key]: typeof val === 'string' ? val : val?.partNo ?? val,
    }),
    autocompleteProps: {
        placeholder: 'Search for part...',
        getOptionLabel: (o) => o?.partNo ?? '',
        isOptionEqualToValue: (o, v) => o?.partNo === v?.partNo,
    },
});

const sourcePartField = createPartAutocompleteField('sourcePartNumber', 'Source Part Number', {
    appliesToIssue: (issue) =>
        !issue?.meta?.invalidParts || !!issue.meta.invalidParts.sourcePartNumber,
});

const relationPartField = createPartAutocompleteField('relationPartNumber', 'Relation Part Number', {
    appliesToIssue: (issue) =>
        !issue?.meta?.invalidParts || !!issue.meta.invalidParts.relationPartNumber,
});

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productRelationAssignment,
    sections: [
        {
            sectionKey: 'invalidPartNumbers',
            sectionTitle: 'Invalid Part Numbers',
            invalidityCode: PreventionInvalidityCode.INVALID_PART,
            fields: [
                sourcePartField,
                relationPartField,
            ],
        },
        {
            sectionKey: 'invalidRelationTitle',
            sectionTitle: 'Invalid Relation Titles',
            invalidityCode: PreventionInvalidityCode.INVALID_RELATION,
            fields: [
                {
                    key: 'sourcePartNumber',
                    label: 'Source Part Number',
                    type: 'text',
                    extractValue: (o) => (typeof o === 'string' ? o : o?.partNumber ?? null),
                },
                createProductRelationAutocompleteField('relationTitle'),
                {
                    key: 'relationPartNumber',
                    label: 'Relation Part Number',
                    type: 'text',
                    extractValue: (o) => (typeof o === 'string' ? o : o?.partNumber ?? null),
                },
            ],
        },
        {
            sectionKey: 'invalidRelationAssignment',
            sectionTitle: 'Source and Relation Part Are the Same',
            invalidityCode: PreventionInvalidityCode.INVALID_RELATION_ASSIGNMENT,
            fields: [
                sourcePartField,
                createProductRelationAutocompleteField('relationTitle'),
                relationPartField,
            ],
        },
        {
            sectionKey: 'missingProductRelationFields',
            sectionTitle: 'Missing Required Fields',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                sourcePartField,
                createProductRelationAutocompleteField('relationTitle'),
                relationPartField,
            ],
        },
    ],
};
